<template>
  <label
    class="flex relative gap-2 items-start lg:cursor-pointer"
    :class="isReadOnly && 'cursor-not-allowed'"
  >
    <span>
      <input
        type="radio"
        value="value"
        class="hidden peer"
        :checked="isChecked"
        :disabled="isReadOnly"
        @change="!isReadOnly && $emit('update:model-value', value)"
      >
      <span
        class="block relative mt-1 w-5 h-5 rounded-full border bg-surface-elevated peer-checked:border-2"
        :class="{
          'border-gray-400 peer-checked:border-gray-400': isReadOnly,
          'peer-checked:border-primary-600 peer-checked:bg-primary-50/50 dark:peer-checked:bg-primary-900/30': !isReadOnly,
        }"
      />
      <span
        class="absolute block w-2 h-2 rounded-full opacity-0 bg-primary-600 left-[6px] top-2.5 peer-checked:opacity-100"
        :class="isReadOnly && 'bg-gray-400'"
      />
    </span>
    <span :class="isReadOnly && 'text-text-muted'">{{ label }}</span>
  </label>
</template>

<script setup>
defineEmits(['update:model-value'])

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  value: {
    type: [String, Number, Boolean],
    default: 'selected'
  },
  isReadOnly: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: [String, Number, Boolean, Event],
    default: ''
  }
})

const isChecked = computed(() => {
  return props.modelValue === props.value
})
</script>
